import { jsx as _jsx } from "react/jsx-runtime";
import { getCompanySuggestions } from "@/graphql/queries/FilterAutocomplete";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { SearchInput } from "../SearchAutocompleteInput";
import { SearchFormContext } from "../SearchFormContext";
export function CompanyAutocompleteInput() {
    var _a = useContext(SearchFormContext), companyParamKey = _a.companyParamKey, companyValue = _a.companyValue, setCompanyValue = _a.setCompanyValue;
    return (_jsx(SearchInput, { label: "Company name", paramKey: companyParamKey, value: companyValue, setValue: setCompanyValue, gqlQuery: getCompanySuggestions, icon: _jsx(FontAwesomeIcon, { icon: faBuilding }) }));
}
